<template>
  <div class="app-container">
    <el-row class="header">
      <h2>Notifications</h2>
      <router-link to="/notifications/new">
        <el-button
          type="primary"
          :size="isMobile ? 'default' : 'large'"
          icon="PlusElementIcon"
          round
        >
          Add notification
        </el-button>
      </router-link>
    </el-row>
    <LoadingBlock :loading="loading" />
    <div v-if="!loading">
      <AutomationsTable />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue'
import { useAutomationsStore } from '@/store/modules/automations'

import useRouter from '@/hooks/useRouter'
import { ElMessage } from 'element-plus'
import AutomationsTable from './components/AutomationsTable.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'Automations',
  components: {
    AutomationsTable,
    LoadingBlock
  },
  props: {},
  setup(props, context) {
    const automationsStore = useAutomationsStore()
    const loading = computed(() => automationsStore.listLoading)
    const { isMobile } = useResize()

    onMounted(() => {
      automationsStore.FetchItems()
      automationsStore.getAutomationEvents()
    })

    return {
      loading,
      isMobile
    }
  }
})
</script>

<style lang="scss" scoped>
.header {
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
}
</style>
